<div class="float-right">
    <input type="checkbox" class="form-check-input" id="autosave_disable" name="autosave_disable" [(ngModel)]="createParams.autosave_disable" (change)="toggleAutosave()"/>
    <label class="form-check-label mr-2" for="autosave_disable">Disable Autosave</label>
    <i class="fas fa-question-circle mr-2" data-toggle="tooltip" data-placement="bottom" title="Autosave validates form before saving. It saves every minute."></i>
    <button type="button" class="btn-close close" aria-label="Close" (click)="closeFormModal()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
</div>
<nav ngbNav #clientIntakeFormNav="ngbNav" class="nav nav-tabs">
    <ng-container ngbNavItem id="clientIntakeInfo" name="clientIntakeInfo" [destroyOnHide]="false">
        <a ngbNavLink>Client Intake Info</a>
        <ng-template ngbNavContent>
            <h5 class="pt-2">{{editingClientIntake? "Editing Client Intake" : "New Client Intake"}}</h5>
            <form novalidate #currentForm="ngForm">
                <button type="button" class="btn btn-primary mb-2" (click)="saveClientIntake(currentForm.form.valid)" [disabled]="submitting">
                    <span>
                        {{preFillDataForEditMode && editingClientIntake ? 'Update client intake' : 'Create client intake'}}&nbsp;
                        <i *ngIf="submitting" class="fas fa-spinner fa-pulse fa-fw"></i>
                    </span>
                </button>&nbsp;
                <button type="button" class="btn btn-outline-secondary mb-2" (click)="closeFormModal()">Cancel & Reset</button>&nbsp;
                <button type="button" class="btn btn-outline-secondary mb-2" (click)="resetForm()">Reset</button>
                <hr>
                <h5>Matter Information</h5>
                <hr>
                <div class="form-group">
                    <label for="matter_type">Matter Type:</label>
                    <select class="form-control" id="matter_type" name="matter_type" [(ngModel)]="createParams.matter_type_id" (change)="matterTypeSelectionChange();formValididtyAutosave()" required>
                        <option value="" *ngIf="!createParams.matter_type_id"></option>
                        <option *ngFor="let matterType of formOptions.matter_types" [value]="matterType.id">{{ matterType.name }}</option>
                    </select>
                    <div class="invalid-feedback d-block" *ngIf="!createParams.matter_type_id && submitted">Matter Type must be selected</div>
                </div>
                <div class="form-group">
                    <label for="rate_type">Rate Type:</label>
                    <select class="form-control" id="rate_type" name="rate_type" [(ngModel)]="createParams.rate_type_id" required (change)="formValididtyAutosave()">
                        <option value="" *ngIf="!createParams.rate_type_id"></option>
                        <option *ngFor="let rateType of formOptions.rate_types" [value]="rateType.id">{{ rateType.name }}</option>
                    </select>
                    <div class="invalid-feedback d-block" *ngIf="!createParams.rate_type_id && submitted">Rate Type must be selected</div>
                </div>
                <div class="form-group">
                    <label for="client_name">Client Name</label>
                    <input type="text" class="form-control" name="client_name" id="client_name" [(ngModel)]="createParams.client_name"/>
                    <span id="client_name_help" name="client_name_help" class="form-text text-muted">The above field will not be added as an involvement when the matter is created - it is for reference only</span>
                </div>
                <div class="form-group">
                    <label>Client Contact:</label>
                    <app-contact-search id="client_contact" name="client_contact" (contact_id)="createParams.client_contact_id = $event"></app-contact-search>
                    <span id="client_name_help" name="client_name_help" class="form-text text-muted">This field is mandatory when a matter is created. It can be omitted for saving the client intake.</span>
                    <div class="form-group form-check">
                        <input type="checkbox" class="form-check-input" id="priority" name="priority" [(ngModel)]="createParams.priority"/>
                        <label class="form-check-label text-danger" for="priority">This Intake is a priority</label>
                    </div>
                </div>
                <div class="form-group">
                    <label for="referral_type">Referral Type:</label>
                    <select class="form-control" id="referral_type" name="referral_type" [(ngModel)]="createParams.referral_type_id" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }" required (change)="formValididtyAutosave()">
                        <option value="" *ngIf="!createParams.referral_type_id"></option>
                        <option *ngFor="let referralType of formOptions.referral_types" [value]="referralType.id">{{ referralType.name }}</option>
                    </select>
                    <div class="invalid-feedback d-block" *ngIf="!createParams.referral_type_id && submitted">Referral Type must be selected</div>
                </div>
                <div class="form-group pl-4 pb-2 border-bottom" *ngIf="createParams.referral_type_id">
                    <label for="referral_name" class="pr-2">Referral Name:</label>
                    <button
                        type="button"
                        *ngIf="createParams.referral_person_id"
                        class="btn btn-outline-secondary btn-sm mb-2 pull-right float-right"
                        (click)="modifyClientIntakeFieldValues(null, 'add', 'Referral Name: ' + createParams.referral_person_name)"
                    >
                        Add to Misc
                    </button>&nbsp;
                    <app-contact-search *ngIf="createParams.referral_type_id === '3' || createParams.referral_type_id === '6' || createParams.referral_type_id === '7' || createParams.referral_type_id === '15';else nonContactReferralNameField"
                        id="referral_name"
                        name="referral_name"
                        [include_item]="true"
                        (clearContact)="createParams.referral_person_id = undefined"
                        (contact)="createParams.referral_person_name = $event.value"
                        (contact_id)="createParams.referral_person_id = $event"
                    >
                    </app-contact-search>
                    <ng-template #nonContactReferralNameField>
                        <input type="text" id="referral_name" class="referral_name form-control" [(ngModel)]="createParams.referral_person_name" #ctrl="ngModel" [ngModelOptions]="{ standalone: true }"/>
                    </ng-template>
                </div>
                <div class="form-group">
                    <label for="assigned_attorney">Assign to Attorney:</label>
                    <select class="form-control" id="assigned_attorney" name="assigned_attorney" [(ngModel)]="createParams.attorney_id" required (change)="formValididtyAutosave()">
                        <option value="" *ngIf="!createParams.attorney_id"></option>
                        <option *ngFor="let attorney of formOptions.attorneys" [value]="attorney.id">{{ attorney.name }}</option>
                    </select>
                    <div class="invalid-feedback d-block" *ngIf="!createParams.attorney_id && submitted">Attorney must be selected</div>
                </div>
                <div class="form-group">
                    <label for="opener_attorney">Opener Attorney:</label>
                    <select class="form-control" id="opener_attorney" name="opener_attorney" [(ngModel)]="createParams.opener_id">
                        <option value="" *ngIf="!createParams.opener_id"></option>
                        <option *ngFor="let attorney of formOptions.attorneys" [value]="attorney.id">{{ attorney.name }}</option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="client_contact">Parent Matter:</label>
                    <app-matter-search id="client_contact" name="client_contact" [matterId]="createParams.parent_matter_id" (matter_id)="createParams.parent_matter_id = $event"></app-matter-search>
                </div>
                <h5>Default Appointment Location</h5>
                <div class="form-group">
                    <app-contact-search id="client_contact" name="client_contact" [contactId]="defaultAppointmentLocation" [params]="{contact_type:'Company'}" (contact_id)="createParams.default_appointment_location = $event"></app-contact-search>
                </div>
                <div class="form-group pl-4">
                    <label for="default_appointment_address">Default Appointment Address:</label>
                    <select class="form-control" id="default_appointment_address" name="default_appointment_address" [(ngModel)]="createParams.default_appointment_address_id" required (change)="formValididtyAutosave()">
                        <option value="" *ngIf="!createParams.default_appointment_address_id"></option>
                        <option *ngFor="let defaultAppointmentAddress of formOptions.default_appointment_addresses" [value]="defaultAppointmentAddress.id">{{ defaultAppointmentAddress.label }}</option>
                    </select>
                    <div class="invalid-feedback d-block" *ngIf="!createParams.default_appointment_address_id && submitted">Default Appointment Address must be selected</div>
                </div>
                <hr>
                <h5>New Client Appointment</h5>
                <div class="form-group pl-4">
                    <label for="appointment_date_and_time">Date & Time</label>
                    <app-datetime-picker
                        name="appointment_date_and_time"
                        id="appointment_date_and_time"
                        [datetime]="createParams.client_intake_appointment_formatted_date"
                        [hideExtraLine]="true"
                        [showTimePicker]="true"
                        [small]="false"
                        [dateStrSeparator]="'/'"
                        (result)="createParams.client_intake_appointment_date = $event"
                    >
                    </app-datetime-picker>
                </div>
                <div class="form-group pl-4">
                    <label for="appointment_scheduled_notes">Notes</label>
                    <textarea class="form-control" id="appointment_scheduled_notes" name="appointment_scheduled_notes" [(ngModel)]="createParams.appointment_scheduled_notes"></textarea>
                </div>
                <hr>
                <div class="form-group">
                    <label for="tags">Tags</label>
                    <input type="text" class="form-control" name="tags" id="tags" [(ngModel)]="createParams.tag_list"/>
                </div>
                <div class="form-group">
                    <label for="notice">Notice</label>
                    <textarea class="form-control" name="notice" id="notice" [(ngModel)]="createParams.notice"></textarea>
                </div>
                <div class="form-group">
                    <label for="history">History</label>
                    <textarea class="form-control" name="history" id="history" [(ngModel)]="createParams.history"></textarea>
                </div>
                <div class="form-group">
                    <label for="notes">Notes</label>
                    <textarea class="form-control" name="notes" id="notes" [(ngModel)]="createParams.notes"></textarea>
                </div>
                <h5>Miscellaneous</h5>
                <hr>
                <div class="form-group">
                    <div class="row">
                        <div class="col-md-6 col-sm-12">
                            <label for="miscellaneous_details">Miscellaneous Details</label>
                            <div class="input-group">
                                <input type="text" class="form-control" name="miscellaneous_details" id="miscellaneous_details" [(ngModel)]="createParams.client_intake_misc_detail_temp">
                                <div class="input-group-append">
                                    <button type="button" class="btn btn-primary" (click)="modifyClientIntakeFieldValues(null, 'add', createParams.client_intake_misc_detail_temp)">Add</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6 col-sm-12 pt-1">
                            <table class="table table-sm">
                                <tbody>
                                    <tr *ngFor="let detail of miscellaneousDetails" class="table-primary">
                                        <td colspan="9">
                                            <span style="margin-left: 10px;">
                                                {{detail.value}}
                                            </span>
                                        </td>
                                        <td colspan="3">
                                            <button class="btn btn-link btn-sm float-right" (click)="modifyClientIntakeFieldValues(null, 'sub', detail)" style="color:firebrick;padding: 1px;margin-right: 10px;" type="button">
                                                <i class="fas fa-minus-circle"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="other_legal_matter_notes">Other Legal Matter's Notes</label>
                    <textarea class="form-control" id="other_legal_matter_notes" name="other_legal_matter_notes" [(ngModel)]="createParams.other_legal_matter_notes"></textarea>
                </div>
                <div class="form-group form-check">
                    <input type="checkbox" class="form-check-input" id="court_appointed" name="court_appointed" [(ngModel)]="createParams.court_appointed"/>
                    <label class="form-check-label" for="court_appointed"> Court appointed</label>
                </div>
                <div class="form-group form-check">
                    <input type="checkbox" class="form-check-input" id="pro_bono" name="pro_bono" [(ngModel)]="createParams.pro_bono"/>
                    <label class="form-check-label" for="pro_bono">Pro bono</label>
                </div>
                <div class="form-group form-check">
                    <input type="checkbox" class="form-check-input" id="incomplete_client_contact" name="incomplete_client_contact" [(ngModel)]="createParams.not_ready_for_matter"/>
                    <label class="form-check-label" for="incomplete_client_contact">Incomplete client contact</label>
                </div>
                <div class="form-group text-center">
                    <button type="button" class="btn btn-primary mb-2" (click)="saveClientIntake(currentForm.form.valid)" [disabled]="submitting">
                        <span>
                            {{preFillDataForEditMode && editingClientIntake ? 'Update client intake' : 'Create client intake'}}&nbsp;
                            <i *ngIf="submitting" class="fas fa-spinner fa-pulse fa-fw"></i>
                        </span>
                    </button>&nbsp;
                    <button type="button" class="btn btn-outline-secondary mb-2" (click)="closeFormModal()">Cancel & Reset</button>&nbsp;
                    <button type="button" class="btn btn-outline-secondary mb-2" (click)="resetForm()">Reset</button>
                </div>
            </form>
        </ng-template>
    </ng-container>
    <ng-container ngbNavItem id="matter-type" [destroyOnHide]="false">
        <a ngbNavLink [ngClass]="matterType ? 'text-success' : 'text-danger'">{{matterType ? matterType: 'Matter Type not selected'}}</a>
        <ng-template ngbNavContent>
            <h5 class="pt-2">Matter Type Selection: <span [class]="matterType? 'text-success': 'text-danger'">{{matterType}}</span></h5>
            <div class="row" *ngFor="let clientIntakeField of clientIntakeFields">
                <div class="col-md-12" id="col-md-12-for-client-Intake-Fields">
                    <div class="form-group" id="form-group-for-client-Intake-Fields">
                        <label data-placement="right" data-toggle="tooltip"
                            [innerHtml]="clientIntakeField.prompt | safeHtml"
                            [title]="clientIntakeField.description"
                            [style]="'font-size: clientIntakeField.field_type_obj.is_header ? 130% : null'"
                            [class]="'text-primary: clientIntakeField.field_type_obj.is_header'"
                        >
                        </label>
                        <div *ngIf="!clientIntakeField.field_type_obj.multiple" id="non-multiple-fields">
                            <input [(ngModel)]="clientIntakeField.client_intake_field_value" class="form-control" *ngIf="clientIntakeField.field_type_obj.data_type == 'text'" type="text" />
                            <input [(ngModel)]="clientIntakeField.client_intake_field_value" *ngIf="clientIntakeField.field_type_obj.data_type == 'checkbox'" type="checkbox" />
                            <textarea [(ngModel)]="clientIntakeField.client_intake_field_value" class="form-control" *ngIf="clientIntakeField.field_type_obj.data_type == 'textarea'">
                            </textarea>
                            <div class="input-group" *ngIf="clientIntakeField.field_type_obj.field_linked">
                                <app-contact-search id="default_appointment_location"
                                    [select_only]="clientIntakeField.client_intake_field_value.value"
                                    [placeholder]="'Search and select contact'"
                                    [include_item]="true"
                                    (contact)="clientIntakeField.client_intake_field_value.name = $event.label"
                                >
                                </app-contact-search>
                                <div class="input-group-append">
                                    <button
                                        class="btn btn-primary"
                                        (click)="resetClientIntakeField()"
                                        [disabled]="!clientIntakeField.client_intake_field_value.value"
                                        type="button"
                                    >
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                                            <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="clientIntakeField.field_type_obj.multiple" id="multiple-fields">
                            <div class="row">
                                <div class="col-sm-6 col-md-6">
                                    <app-contact-search id="contact-name" [select_only]="true" [placeholder]="'Search and select contact'" [include_item]="true" (contact)="clientIntakeField.temp_cif_value_name = $event.label;clientIntakeField.temp_cif_value=$event.id; modifyClientIntakeFieldValues(clientIntakeField, 'add', null)" *ngIf="clientIntakeField.field_type_obj.field_linked == 'Contact'"></app-contact-search>
                                    <div class="input-group" *ngIf="clientIntakeField.field_type_obj.field_linked !== 'Contact'">
                                        <app-datetime-picker [hideExtraLine]="true" [clearInputAfterSelection]="clientIntakeField.hasOwnProperty('temp_cif_value') ? false : true" [showTimePicker]="false" (dateStrResult)="clientIntakeField.temp_cif_value = $event" *ngIf="clientIntakeField.field_type_obj.data_type == 'date'"></app-datetime-picker>
                                        <input class="input form-control" *ngIf="clientIntakeField.field_type_obj.data_type == 'text'" [(ngModel)]="clientIntakeField.temp_cif_value" type="text" />
                                        <div class="input-group-append">
                                            <button class="btn btn-primary" (click)="modifyClientIntakeFieldValues(clientIntakeField, 'add', null)" type="button">Add</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6 col-md-6 pt-1">
                                    <table class="table table-sm">
                                        <tbody>
                                            <tr *ngFor="let clientIntakeFieldValue of clientIntakeField.client_intake_field_values" [class]="{'table-success': clientIntakeField.field_type_obj.data_type == 'text', 'table-info': clientIntakeField.field_type_obj.field_linked == 'Contact', 'table-warning': clientIntakeField.field_type_obj.data_type == 'date'}">
                                                <td colspan="9">
                                                    <a class="btn btn-link" [href]="'/contacts/' + clientIntakeFieldValue.value" *ngIf="clientIntakeFieldValue.name" target="_blank">
                                                        {{clientIntakeFieldValue.name}}
                                                    </a>
                                                    <span *ngIf="!clientIntakeFieldValue.name" style="margin-left: 10px;">
                                                        {{clientIntakeFieldValue.value}}
                                                    </span>
                                                </td>
                                                <td colspan="3">
                                                    <button class="btn btn-link btn-sm float-right" (click)="modifyClientIntakeFieldValues(clientIntakeField, 'sub', null)" style="color:firebrick;padding: 1px;margin-right: 10px;" type="button">
                                                        <i class="fas fa-minus-circle"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-template>
    </ng-container>
    <ng-container ngbNavItem id="add-contact" [destroyOnHide]="false">
        <a ngbNavLink>Add Contact</a>
        <ng-template ngbNavContent>
            <h5 class="pt-2">
                New Contact
                <button type="button" class="btn btn-primary mb-2">Save</button>&nbsp;
                <button type="button" class="btn btn-outline-secondary mb-2" (click)="closeFormModal()">Cancel</button>
            </h5><hr>
            <app-contact-form></app-contact-form>
        </ng-template>
    </ng-container>
</nav>
<div [ngbNavOutlet]="clientIntakeFormNav" class="mt-2"></div>
